import { NavigationPosition } from '@unifyapps/defs/types/interface';
import { clsx } from 'clsx';
import { NavigationItemClassName } from '../../constants';
import { isHorizontalUpfrontFn } from '../../helpers';
import {
  buttonNavItemRootVariants,
  navItemIconRootClassName,
  navItemLinkIconVariants,
  navItemLinkLabelVariants,
} from '../../styles';
import type { NavigationItemSlotPropsType } from '../../types';

function getActionNavItemClassNames({
  isActive,
  icon,
  variant,
  disabled,
  navigationItem,
  isPlatformSideNav
}: {
  isActive: boolean;
  icon?: string;
  variant: 'lite' | 'rich';
  disabled?: boolean;
  navigationItem: NavigationItemSlotPropsType['navigationItem'];
  isPlatformSideNav?:boolean;
}) {
  const {
    expanded,
    labelVariant,
    position = NavigationPosition.Start,
    resolution,
    selectionVariant,
    expandableNavVariant,
    alignment,
    direction,
  } = navigationItem ?? {};
  const isHorizontalUpfront = isHorizontalUpfrontFn(labelVariant, selectionVariant, direction);

  const rootClassName = buttonNavItemRootVariants({
    variant,
    active: isActive,
    expanded,
    selectionVariant,
    labelVariant,
    expandableNavVariant,
    disabled,
    className: clsx(
      { 'rounded-xl': variant === 'lite' },
      navItemIconRootClassName({ hasIcon: Boolean(icon) }),
      position && NavigationItemClassName[position],
    ),
    position,
    resolution,
    alignment,
    direction,
    isHorizontalUpfront,
  });

  const iconClassname = navItemLinkIconVariants({
    className: 'shrink-0',
    active: isActive,
    variant,
    labelVariant,
    selectionVariant,
    position,
  });

  const labelClassname = navItemLinkLabelVariants({
    active: isActive,
    expanded,
    variant,
    labelVariant,
    selectionVariant,
    resolution,
    position,
    isPlatformSideNav
  });

  return { rootClassName, iconClassname, labelClassname, isHorizontalUpfront };
}

export { getActionNavItemClassNames };
